import styled from "styled-components";
import { SearcherFliItem, SearcherItemArrayInput } from "../../../searcher-fli/views/desktop/styled.js";
import { SearcherSkeletonWrapper } from "../../../searcher/skeleton/styled.js";
import { SearcherItem, SearcherMiddle, SearcherWrapper } from "../../../searcher/styled.js";
import { AddButton, ArrayInputRow, ArrayInputRowContent, ArrayInputWrapper, RemoveIcon } from "../../../../../forms/inputs/array-input/styled.js";
import { CalendarLabel } from "../../../../../forms/inputs/calendar/styled.js";
import { Skeleton } from "../../../../../structures/others/skeleton/styled.js";
import { Border } from "../../../../../../styles/common/mixins/logical.styled.js";
export const SearcherModalWrapper = styled.div.withConfig({
    displayName: "styled__SearcherModalWrapper",
    componentId: "sc-185d6dfd-0"
})`
	${SearcherWrapper} {
		background-color: ${({ theme  })=>theme.colors.white.base};
	}
	${SearcherItemArrayInput}, ${SearcherItemArrayInput}:not(.searcher-button) {
		${Border({
    all: 'none'
})}
	}
	.Openjaw ${ArrayInputWrapper} {
		padding-right: 0px;
	}
	.Openjaw ${ArrayInputRowContent} > div {
		margin-bottom: 0px;
	}
	.Openjaw ${ArrayInputWrapper} ${SearcherFliItem} {
		flex-basis: max-content;
		max-width: calc(100% / 3 - 10px);
		margin-bottom: 0px;
	}
	.Openjaw ${ArrayInputRow}:nth-child(n+3) ${SearcherFliItem} {
		max-width: calc(90% / 3 - 10px);
		padding: 0;
	}
	.Openjaw [disabled] {
		display: none;
	}
	.Openjaw ${CalendarLabel} {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		max-width: calc(100% - 40px);
	}
	.Openjaw ${RemoveIcon} {
		padding: 0;
	}
	.Openjaw ${AddButton} {
		position: relative;
		margin-top: 12px;
	}
	.Openjaw ${SearcherFliItem}[order="4"], .Openjaw ${SearcherFliItem}[order="7"] {
		display: inline-block;
		width: calc(50% - 8px);
	}
	.Openjaw ${SearcherFliItem}[order="7"] {
		margin-left: 16px;
	}

	${SearcherSkeletonWrapper} {
		${Skeleton} {
			background-color: rgba(0, 0, 0, 0.12);

			&:after {
				background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
				mask-image: radial-gradient(rgb(255, 255, 255), rgb(0, 0, 0));
			}
		}

		${SearcherMiddle} {
			${SearcherItem}:first-of-type {
				display: none;
			}
		}
	}
`;

//# sourceMappingURL=styled.js.map